module.exports = __webpack_public_path__ + "ImagemSemPonto.png?2c4069ad7ba27a4ea179a72a75359fbd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point/ImagemSemPonto.png
// module id = 932
// module chunks = 0